<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  boleto: { type: Object, default: () => ({}) },
  canManage: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['download', 'remove', 'upload']);
const { t } = useI18n();
const fileInput = ref(null);
const selectedFile = ref(null);
const fileError = ref('');
const hasBoleto = () => Boolean(props.boleto?.enviado);

watch(
  [() => props.show, () => props.boleto],
  ([show]) => {
    if (!show) return;
    selectedFile.value = null;
    fileError.value = '';
  },
  { immediate: true }
);

const selectFile = event => {
  const file = event.target.files?.[0];
  selectedFile.value = file || null;
  fileError.value =
    file &&
    (file.type !== 'application/pdf' ||
      !file.name.toLowerCase().endsWith('.pdf'))
      ? t('REAL_ESTATE_FINANCE.BOLETO.INVALID_FILE')
      : '';
};
const upload = () => {
  if (selectedFile.value && !fileError.value)
    emit('upload', selectedFile.value);
};
</script>

<template>
  <input
    ref="fileInput"
    type="file"
    accept="application/pdf,.pdf"
    class="hidden"
    @change="selectFile"
  />
  <div
    class="rounded-lais border border-dashed border-lais-border bg-lais-bg-soft p-4"
  >
    <p class="font-semibold text-lais-text">
      {{ boleto.nome || t('REAL_ESTATE_FINANCE.BOLETO.NO_FILE') }}
    </p>
    <p v-if="fileError" class="mt-1 text-xs text-lais-danger">
      {{ fileError }}
    </p>
    <div class="mt-3 flex flex-wrap gap-2">
      <LaisPrimaryButton
        v-if="canManage"
        size="sm"
        variant="ghost"
        @click="fileInput?.click()"
      >
        {{
          hasBoleto()
            ? t('REAL_ESTATE_FINANCE.BOLETO.REPLACE')
            : t('REAL_ESTATE_FINANCE.BOLETO.UPLOAD')
        }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="selectedFile && !fileError"
        size="sm"
        :is-loading="loading"
        @click="upload"
      >
        {{ t('REAL_ESTATE_FINANCE.BOLETO.SEND_FILE') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="boleto.pode_baixar"
        size="sm"
        variant="ghost"
        @click="emit('download')"
      >
        {{ t('REAL_ESTATE_FINANCE.BOLETO.DOWNLOAD') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="hasBoleto() && canManage"
        size="sm"
        variant="ghost"
        @click="emit('remove')"
      >
        {{ t('REAL_ESTATE_FINANCE.BOLETO.REMOVE') }}
      </LaisPrimaryButton>
    </div>
  </div>
</template>
